<script setup>
import { FormKit } from '@formkit/vue';

const props = defineProps({
    context: Object
})
</script>
<template>
    <div class="formkitProperty w-100">
        <FormKit id="aUrlLink" class="selectInputField formkit-inner" type="url" name="@id"
            :help="props.context.help" :placeholder="props.context.attrs.placeholder"
            validation-label="Zugangs-URL"
            :validation="props.context.attrs.validationType" @input="saveUrl" />
    </div>
</template>
<style></style>
